import { QueryParams } from '@ml/shared/types/query-params';
var OrdersFilters = /** @class */ (function () {
    function OrdersFilters(status) {
        this.status = status;
    }
    Object.defineProperty(OrdersFilters.prototype, "queryParams", {
        get: function () {
            var params = new QueryParams();
            if (this.status) {
                params.status = this.status.join(',');
            }
            if (this.ordering) {
                params.ordering = this.ordering;
            }
            return params;
        },
        enumerable: true,
        configurable: true
    });
    OrdersFilters.fromParams = function (params) {
        var ordersFilter = new OrdersFilters();
        if (params.status) {
            ordersFilter.status =
                typeof params.status === 'string' ? [params.status] : params.status;
        }
        if (params.ordering) {
            ordersFilter.ordering = params.ordering;
        }
        return ordersFilter;
    };
    Object.defineProperty(OrdersFilters.prototype, "params", {
        get: function () {
            var params = {};
            if (this.status) {
                params.status = this.status;
            }
            if (this.ordering) {
                params.ordering = this.ordering;
            }
            return params;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrdersFilters.prototype, "empty", {
        get: function () {
            return !(this.status && this.status.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    return OrdersFilters;
}());
export { OrdersFilters };
